var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 0.9375H3.51628V0H0V3.50678H0.9375V0.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 12.4837H0V16H3.50678V15.0625H0.9375V12.4837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4836 0V0.9375H15.0624V3.50678H15.9999V0H12.4836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0624 15.0625H12.4932V16H15.9999V12.4837H15.0624V15.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 1.77194L3.11523 4.5776L8.00005 7.38322L12.8849 4.5776L8.00005 1.77194Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3527 5.39001L8.46875 8.19514V13.9589L13.3527 11.1537V5.39001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64722 11.1537L7.53115 13.9589V8.19514L2.64722 5.39001V11.1537Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssSelectIcon);
export default __webpack_public_path__ + "static/media/essSelectIcon.d23837d51313458bc5fc86ad650b2ee6.svg";
export { ForwardRef as ReactComponent };